/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { Link } from 'react-router-dom';

import {
  Box,
  Button, KeyIcon, Typography,
  styled,
} from '@datanomik/commons-ui';

import { GppGoodOutlined } from '@mui/icons-material';

import Modal from '@/views/common/Modal';
import { useFormContext } from '@/contexts/form';

import Grid from '@/views/common/Grid';
import CodeInput from '@/views/common/CodeInput';
import InputField from '@/views/common/InputField';

import styles, { modalStyles } from './styles';
import useVerificationCodeRaw from './hooks';

const VerificationCodeRaw = ({ className, signUpInfo, onClose = () => {} }) => {
  const { formSubmit } = useFormContext();
  const {
    formData,
    openModal,
    handleResend,
    handleMobileResend,
    handleConfirm,
    handleCloseModal,
    handleOnChangeCode,
  } = useVerificationCodeRaw({ userData: signUpInfo, onClose });

  const { email = t('email') } = signUpInfo;

  const dialogActions = (
    <Box sx={{ width: '100% !important' }}>
      <Grid container>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
          >
            {t('Verify Email')}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="text"
            color="black"
            component={Link}
            fullWidth
            onClick={handleResend}
          >
            {t('Resend email verification code')}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="text"
            color="black"
            component={Link}
            fullWidth
            onClick={handleMobileResend}
          >
            {t('Resend mobile verification code')}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Box className={className}>
      <Modal
        openModal={openModal}
        closeModal={handleCloseModal}
        backdropClose={false}
        title="Verification"
        sx={modalStyles}
        DialogProps={{
          maxWidth: 'sm',
          PaperProps: {
            sx: { minWidth: '400px' },
          },
        }}
        DialogHeaderProps={{
          text: t('Verification'),
          startAdornment: (
            <KeyIcon color="neutral">
              <GppGoodOutlined />
            </KeyIcon>
          ),
        }}
        DialogActionsProps={{ dialogActions }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="p3" color="text.500" align="center">
              <Trans i18nKey="Enter the verification code that has been sent to {{email}}">
                Enter the verification code that has been sent to
                {' '}
                <strong>{{ email }}</strong>
              </Trans>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="p5" color="text.400" align="center">
              <Trans i18nKey="The code sent is valid for 60 minutes.">
                This code is valid for 60 minutes. Some Outlook users may experience delays in receiving the confirmation email. Please check your SPAM inbox.
              </Trans>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <form onSubmit={formSubmit(handleConfirm)} noValidate>
              <Grid container justifyContent="center" textAlign="center">
                <Grid item xs={12}>
                  <InputField
                    value={formData.code}
                    name="code"
                    type="text"
                    className="dn-hidden"
                    required
                    label=""
                  />
                  <CodeInput
                    onChange={handleOnChangeCode}
                    placeholder={['-', '-', '-', '-', '-', '-']}
                  />
                </Grid>

              </Grid>
            </form>
          </Grid>
        </Grid>
      </Modal>
    </Box>
  );
};

VerificationCodeRaw.propTypes = {
  className: PropTypes.string,
  signUpInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

const VerificationCode = styled(VerificationCodeRaw)(styles);

VerificationCode.propTypes = VerificationCodeRaw.propTypes;

export default VerificationCode;
